import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { brl } from "@/lib/api";
import { StatusBadge } from "@/components/StatusBadge";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Loader2 } from "lucide-react";

export default function Loans() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("emprestimo_ativo");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = useCallback(async () => {
    setLoading(true);
    const { data } = await api.get(`/loans?status=${tab}`);
    setItems(data); setLoading(false);
  }, [tab]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-5 fade-up" data-testid="loans-page">
      <div><h1 className="text-2xl font-extrabold tracking-tight">Empréstimos</h1><p className="text-slate-500 text-sm">Empréstimos originados de contratos assinados.</p></div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="emprestimo_ativo" data-testid="loans-tab-ativo">Ativos</TabsTrigger>
          <TabsTrigger value="finalizado" data-testid="loans-tab-finalizado">Finalizados</TabsTrigger>
        </TabsList>
      </Tabs>
      <div className="trt-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-xs uppercase">
            <tr><th className="text-left px-4 py-3">Contrato</th><th className="text-left px-4 py-3">Cliente</th>
              <th className="text-left px-4 py-3 hidden md:table-cell">Total</th><th className="text-left px-4 py-3 hidden md:table-cell">Recebido</th>
              <th className="text-left px-4 py-3 hidden lg:table-cell">Saldo</th><th className="text-left px-4 py-3">Status</th></tr>
          </thead>
          <tbody>
            {loading ? <tr><td colSpan={6} className="py-10 text-center"><Loader2 className="w-6 h-6 animate-spin gold-text mx-auto" /></td></tr>
              : items.length === 0 ? <tr><td colSpan={6} className="py-10 text-center text-slate-400">Nenhum empréstimo.</td></tr>
              : items.map((c) => (
                <tr key={c.id} className="border-t hover:bg-slate-50 cursor-pointer" onClick={() => navigate(`/contratos/${c.id}`)} data-testid={`loan-row-${c.id}`}>
                  <td className="px-4 py-3 font-semibold mono">{c.numero}</td>
                  <td className="px-4 py-3">{c.cliente_nome}</td>
                  <td className="px-4 py-3 hidden md:table-cell font-bold">{brl(c.valor_total)}</td>
                  <td className="px-4 py-3 hidden md:table-cell text-emerald-600">{brl(c.financeiro?.total_recebido ?? c.valor_pago)}</td>
                  <td className="px-4 py-3 hidden lg:table-cell">{brl(c.financeiro?.saldo_restante ?? (c.valor_total - c.valor_pago))}</td>
                  <td className="px-4 py-3"><StatusBadge status={c.status} /></td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
